/**
 * 褒めてくれる 2 人の似顔絵。
 *
 * 画像は web/public/personas/ に置いてあり、CloudFront から配信される
 * (JS バンドルには含めない)。強度 1〜5 で絵柄が変わる。
 */
import type { Persona, Tier } from '../praise';

const FILE: Record<Persona, string> = { macho: 'goshi', gyaru: 'harupippi' };

export function PersonaAvatar({
  persona,
  tier,
  size = 104,
}: {
  persona: Persona;
  tier: Tier;
  size?: number;
}) {
  return (
    <img
      className="persona-img"
      src={`/personas/${FILE[persona]}-${tier}.webp`}
      width={size}
      height={size}
      alt=""
      loading="eager"
      decoding="async"
      draggable={false}
    />
  );
}

/** 強度 1〜5 の全画像を先に読み込んでおく (保存直後に出るので間に合わせたい) */
export function preloadPersonaImages(): void {
  for (const file of Object.values(FILE)) {
    for (let tier = 1; tier <= 5; tier++) {
      const img = new Image();
      img.src = `/personas/${file}-${tier}.webp`;
    }
  }
}
